import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "contact" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Please reach us by email at "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:pglass@swisstech.ca" }, "pglass@swisstech.ca")
  ])
], -1)

import LayoutDefault from "@/layouts/LayoutDefault.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutDefault, { title: "Contact Us" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})